import React from "react";
import { Stack, CircularProgress } from "@mui/material";


export default function CircularProgressView() {
  return (
    <Stack
      sx={{
        width: "100%",
        height: "calc(100vh - 64px)",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <CircularProgress />
    </Stack>
  )
}
